export default __webpack_public_path__ + "static/media/figuremap27.90956424.png";